module.exports = __webpack_public_path__ + "img/[可怜].c6a32204.svg";